import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

const MediosDePagoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)
  const [mediosDePago, setMediosDePago] = React.useState([])

  React.useEffect(() => {
    TablasPersonalizadasService.getAsSelect(TiposTablaPersonalizadaConstant.MEDIOSPAGO)
      .then(({ data }) => {
        setMediosDePago(data)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('text-numeroDocumentoPago', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='MEDIO' htmlFor='select-medioDePago' md={4} size='sm' />
      <Col md={8}>
        <Field name='medioDePago'>
          {({ field }) => (
            <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-medioDePago' onKeyDown={onKeyDown}>
              <option value=''>Seleccionar</option>
              {mediosDePago.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MediosDePagoFormGroup)
